import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../../core/Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

// Form del Buscador
export const StyledSearch = styled.div`
  display: flex;
  margin-bottom: 0;
  width: 100%;

  ${mediaqueries.lessThan('desktop')`
    margin-top: 15px;
    margin-bottom: 20px;
  `}
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('229px')};
    margin-left: 1%;
    margin-top: 4%;
  `};
`;

// Icono de lupa
export const StyledIconSearch = styled(Icon)`
  height: ${rem('34px')};
  margin-right: ${rem('2px')};
  width: ${rem('34px')};
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('24px')};
    margin-right:0;
    width: ${rem('24px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    fill: ${props => props.theme.colors.dark};
    height: ${rem('24px')};
    margin-right:0;
    width: ${rem('24px')};
  `};
`;

// Boton de búsqueda
export const StyledButtonSearch = styled.button`
  background-color: transparent;
  border: 0;
  ${mediaqueries.greaterThan('desktop')`
    display: block;
    background-color: ${props => props.theme.colors.light};
    margin-top:0;
    width: ${rem('72px')};
    margin-left: auto;
  `};
`;

// Input del buscador
export const StyledInput = styled.input`
  background-color: ${props => props.theme.colors.grayLighter};
  border: 0;
  display: none;
  font-size: ${props => props.theme.fontSize.medium};
  padding-left: ${rem('19px')};
  padding-right: ${rem('15px')};
  width: 100%;
  &:focus {
    outline: none;
  }
  &::placeholder {
    font-family: ${props => props.theme.fonts.bookItalic};
  }
  ${mediaqueries.lessThan('desktop')`
    display:block;
  `};
  ${mediaqueries.greaterThan('desktop')`
    display:block;
    padding-top:${rem('4px')};
  `};
`;
